<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-file-invoice"></i> Nota Supplier
                </div>
                <div class="card-tools mr-0">
                    <button
                        :disabled="isLoading"
                        class="btn btn-primary"
                        @click="exportExcel()"
                    >
                        <i class="fa fa-file-excel"></i> Export Excel
                    </button>
                    <button
                        :disabled="isLoading"
                        type="button"
                        class="btn btn-primary"
                        @click="printList"
                    >
                        <i class="fas fa-print"></i> Print
                    </button>
                    <router-link
                        v-if="$can('create nota supplier')"
                        to="/nota-supplier/create"
                        class="btn btn-primary"
                    >
                        <i class="fas fa-plus-square"></i> Nota Supplier
                    </router-link>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar
                        @search-set="searchSet"
                        @search-reset="searchReset"
                    ></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable
                        ref="vuetable"
                        api-url="/api/nota-suppliers"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="pajak" slot-scope="props">
                            <span v-if="props.rowData.pajak_status"
                                >{{ formatNumber(props.rowData.pajak) }}%</span
                            >
                            <span v-else>-</span>
                        </template>
                        <template slot="admin" slot-scope="props">
                            <span v-if="props.rowData.admin_status">{{
                                formatNumber(props.rowData.admin)
                            }}</span>
                            <span v-else>-</span>
                        </template>
                        <template slot="potongan" slot-scope="props">
                            <span v-if="props.rowData.potongan_status">{{
                                formatNumber(props.rowData.potongan)
                            }}</span>
                            <span v-else>-</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button
                                type="button"
                                title="View"
                                @click="view(props.rowData)"
                                class="btn btn-link px-1"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                            <button
                                :disabled="isLoading"
                                @click="print(props.rowData.id)"
                                type="button"
                                class="btn btn-link px-1"
                            >
                                <i class="fas fa-print"></i>
                            </button>
                            <button
                                :disabled="isLoading"
                                @click="exportExcel(props.rowData.id)"
                                type="button"
                                class="btn btn-link px-1"
                            >
                                <i class="fa fa-file-excel"></i>
                            </button>
                            <button
                                v-if="
                                    ($can('create nota supplier') &&
                                        isSameDay(props.rowData.created_at)) ||
                                    isSuperAdmin
                                "
                                type="button"
                                title="Edit"
                                @click="edit(props.rowData)"
                                class="btn btn-link px-1"
                            >
                                <i class="fas fa-edit"></i>
                            </button>
                            <button
                                v-if="isSuperAdmin"
                                type="button"
                                title="Delete"
                                @click="deleteItem(props.rowData)"
                                class="btn btn-link px-1 text-danger"
                            >
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination
                        ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page
                        :perPage="perPage"
                        @update="onChangePerPage"
                    ></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal
            v-model="showEditForm"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
        >
            <edit-form
                :is-edit="isEdit"
                :value="currentNota"
                @saved="saved"
                @cancel="showEditForm = false"
            ></edit-form>
        </b-modal>
    </section>
</template>

<script>
import VuetableMixin from "../../mixin/vuetable2";
import SearchBar from "./SearchBar";
import ExportMixin from "../../mixin/export";
import EditForm from "./Form";

export default {
    name: "nota-supplier",

    components: {
        SearchBar,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentNota: null,
            searchText: "",
            searchDate: "",
            searchSupplierId: "",
            showEditForm: false,
            showScanQrCode: false,
            isEdit: false,
            exportUrl: "/export/nota-suppliers",
        };
    },

    created() {},

    mounted() {},

    computed: {
        customFields() {
            return [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: "created_at",
                    title: "Tanggal",
                    sortField: "created_at",
                    callback: "formatDate",
                },
                {
                    name: "supplier.name",
                    title: "Supplier",
                    sortField: "supplier_name",
                },
                {
                    name: "sub_total",
                    title: "Sub Total",
                    sortField: "sub_total",
                    callback: "formatNumber",
                },
                {
                    name: "__slot:pajak",
                    title: "Pajak",
                    sortField: "pajak",
                    callback: "formatNumber",
                },
                {
                    name: "__slot:admin",
                    title: "Admin",
                    sortField: "admin",
                    callback: "formatNumber",
                },
                {
                    name: "__slot:potongan",
                    title: "Potongan",
                    sortField: "potongan",
                    callback: "formatNumber",
                },
                {
                    name: "total",
                    title: "Total",
                    sortField: "total",
                    callback: "formatNumber",
                },
                {
                    name: "user.name",
                    title: "Dibuat Oleh",
                    sortField: "user_name",
                },
                {
                    name: "created_at",
                    title: "Tanggal Dibuat",
                    sortField: "created_at",
                    callback: "formatDate",
                },
                {
                    name: "__slot:action",
                    title: "Aksi",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ];
        },

        sortOrder() {
            return [{ field: "updated_at", direction: "desc" }];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                supplier_id: this.searchSupplierId,
                grade_id: this.searchGradeId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchSupplierId = search.searchSupplierId;
            this.refresh();
        },

        searchReset() {
            this.searchText = "";
            this.searchDate = "";
            this.searchSupplierId = "";
            this.refresh();
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentNota = Object.assign({}, rowData);
            this.showEditForm = true;
        },

        view(rowData) {
            this.isEdit = false;
            this.currentNota = Object.assign({}, rowData);
            this.showEditForm = true;
        },

        saved() {
            this.showEditForm = false;
            this.currentNota = null;
            this.refresh();
        },

        print(id) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement("iframe");
            newIframe.width = "0";
            newIframe.height = "0";
            newIframe.src = "/nota-suppliers/print/" + id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit("cancel");
            };
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement("iframe");
            newIframe.width = "0";
            newIframe.height = "0";
            let params = this.convertExportParams("print");
            newIframe.src = `/nota-suppliers/list/print` + "?" + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            };
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: "Apakah anda yakin?",
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Ya, hapus!",
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: "delete",
                        url: "/api/nota-suppliers/" + rowData.id,
                    })
                        .then(function (response) {
                            Toast.fire({
                                icon: "success",
                                title: response.data.message,
                            });
                            self.isLoading = false;
                            self.$Progress.finish();
                            self.refresh();
                        })
                        .catch(function (error) {
                            self.responseFailed(error);
                        });
                }
            });
        },
    },
};
</script>
